import { useEffect } from 'react';

const Home = () => {
    useEffect(() => {
        window.location.href = 'https://www.tcot.com'; 
      }, []);
};
 
export default Home;